import React from "react";
import styled, { css } from "styled-components";

const StyledIcon = styled.svg`
  fill: none;
  stroke: #454545;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
  stroke-width: 3px;

  ${({ darkMode }) =>
    darkMode == "true" &&
    css`
      stroke: #ffffff;
    `}
`;

const NextArrow = ({ darkMode }) => {
  return (
    <StyledIcon
      darkMode={darkMode}
      xmlns="http://www.w3.org/2000/svg"
      width="24.622"
      height="46.245"
      viewBox="0 0 24.622 46.245"
    >
      <g transform="translate(2.121 2.121)">
        <path d="M0,0,21,21,0,42" />
      </g>
    </StyledIcon>
  );
};

export default NextArrow;
